<template>
    <h6 class="mt-2 mb-1 ml-1">{{ value }}</h6>
</template>

<script>
export default {
    components: {
    },
    props: {
        value: {
            type: String,
            required: true,
            default() {
                return ''
            },
        },
    },
    data() {
        return {}
    },
    computed: {},
    async mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped>
</style>

